import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import { mediaQueries } from "shared/config/breakpoints";
import styled from "styled-components";

export const ResponsiveErrorMessage = styled.div`
    font-size: 16px;
    text-align: center;
    padding: 20px;
    color: ${COLOR_VALUES.Orange_1};

    ${mediaQueries.small} {
        font-size: 14px;
        padding: 16px;
    }
`;

export const StyledErrorHStack = styled(HStack)`
    ::after {
        content: "";
        width: 100%;
        height: 2px;
        background: ${COLOR_VALUES.Orange_1};
        display: block;
        position: absolute;
        bottom: -2px;
    }

    ${mediaQueries.small} {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;

        div {
            font-size: 0.75rem;
            line-height: 1.4;
        }
    }
        left: 0;
    }
`;
